var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-content"},[(_vm.title)?_c('p',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.iconName}}),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }